import React from 'react';
import { Button, Col, Row } from 'antd';
import { ButtonGroup, Divider } from '@common/components';
import {
  SubmittalPacketLastUpdatedInfo,
  SubmittalPacketChangeRequestDrawerTrigger,
  SubmittalPacketPreviewerDrawerTrigger,
} from '@applicant-flow/components';
import { SubmittalPacketInfoType } from 'works/legacy/graphql/submittal-packet';
import { titleize } from '@common/services';

type Props = {
  summary: string;
  submittalPacket: SubmittalPacketInfoType;
  availableToStartAt: string;
  timeoffDescription: string;
  interviewAvailability: string;
  employmentType: string;
  displayApplicationInformation: boolean;
  applicationId: string;
  applicationState: string;
};

export function ApplicationSummary({
  summary,
  availableToStartAt,
  timeoffDescription,
  interviewAvailability,
  employmentType,
  displayApplicationInformation,
  submittalPacket,
  applicationId,
  applicationState,
}: Props) {
  return (
    <>
      <Row className="ui-summary__container">
        <Col span={24}>
          <ButtonGroup>
            <SubmittalPacketPreviewerDrawerTrigger
              submittalPacketId={submittalPacket.id}
              applicationId={applicationId}
              applicationState={applicationState}
            />
            <SubmittalPacketChangeRequestDrawerTrigger
              applicationId={applicationId}
              applicationState={applicationState}
            >
              <Button type="link">Change Request</Button>
            </SubmittalPacketChangeRequestDrawerTrigger>
          </ButtonGroup>
        </Col>
        <Col span={24}>
          <Divider gutter />
        </Col>
        <Col span={24}>
          <div style={{ marginBottom: 16 }}>
            <SubmittalPacketLastUpdatedInfo applicationId={applicationId} />
          </div>
        </Col>
        <Col span={24}>
          <p>{summary}</p>
        </Col>
        {displayApplicationInformation && (
          <Col span={24}>
            Available To Start:&nbsp;
            <span>
              <strong>{availableToStartAt}</strong>
            </span>
          </Col>
        )}
        <Col span={24}>
          Requested Time Off:&nbsp;
          <span>
            <strong>{timeoffDescription}</strong>
          </span>
        </Col>
        {displayApplicationInformation && (
          <Col span={24}>
            Interview Availability:&nbsp;
            <span>
              <strong>{interviewAvailability}</strong>
            </span>
          </Col>
        )}
        <Col span={24}>
          Employment Type:&nbsp;
          <span>
            <strong>{titleize(employmentType)}</strong>
          </span>
        </Col>
      </Row>
      <style jsx>{`
        :global(.ui-summary__container) {
          margin: 24px 0;
        }
      `}</style>
    </>
  );
}
